import { render, staticRenderFns } from "./Alergia.vue?vue&type=template&id=56c12796&"
import script from "./Alergia.vue?vue&type=script&lang=js&"
export * from "./Alergia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports